module.exports = __webpack_public_path__ + "img/weixin.dbdafb2d.png";